/**
 * Human-readable labels for document-type keys. Ported verbatim from
 * src/app/docpic/document-classify.ts (documentTypeLabel + its tables) so the
 * lib produces the same labels as the app.
 */

/** type-key → human label for the well-known Brazilian documents. */
export const DOC_TYPE_LABELS: Record<string, string> = {
  cnh: 'CNH — Carteira Nacional de Habilitação',
  cin: 'CIN — Carteira de Identidade Nacional',
  rg: 'RG — Carteira de Identidade',
  cpf: 'CPF — Cadastro de Pessoas Físicas',
  passaporte: 'Passaporte',
  'titulo-eleitor': 'Título de Eleitor',
  ctps: 'CTPS — Carteira de Trabalho',
  'nota-fiscal': 'Nota Fiscal',
  comprovante: 'Comprovante de Residência / Fatura',
};

/** Acronyms that should stay uppercase when formatting a type key. */
const TYPE_ACRONYMS = new Set(['cin', 'cnh', 'rg', 'cpf', 'ctps', 'cnpj', 'qr']);

/**
 * Human label for a type key. Known keys use their canonical label; otherwise a
 * trained key like `cin-back` / `cnh-digital` is formatted as "CIN — Back" /
 * "CNH — Digital" (first segment = document, rest = the side/variant).
 */
export function documentTypeLabel(type: string): string {
  if (DOC_TYPE_LABELS[type]) return DOC_TYPE_LABELS[type];
  if (type === 'unknown') return 'Unknown document';
  const parts = type.split('-').map((p) =>
    TYPE_ACRONYMS.has(p) ? p.toUpperCase() : p.charAt(0).toUpperCase() + p.slice(1),
  );
  return parts.length > 1 ? `${parts[0]} — ${parts.slice(1).join(' ')}` : parts[0];
}
